import React, { useState, useRef, useEffect } from "react";
import { FormInputs, FormSelects } from "components/FormInputSelect";
import CustomButton from "components/CustomButton";
import InfoTooltip from "components/InfoTooltip";
import { API_GET_MAMBOO } from "services";
import "./BankAndVerified.scss";

const BankAndVerified = ({
	dataBank,
	uploadDokumen,
	addFile,
	getProfile,
	isPayload,
	setIsPayload,
}) => {
	const [isForm, setIsForm] = useState({
		bank:
			getProfile && getProfile?.bank_accounts?.bank
				? getProfile.bank_accounts.bank
				: "",
		account_number:
			getProfile && getProfile?.bank_accounts?.account_number
				? getProfile.bank_accounts.account_number
				: "",
		account_name:
			getProfile && getProfile?.bank_accounts?.account_name
				? getProfile.bank_accounts.account_name
				: "",
	});
	const [filePreviewUrl, setFilePreviewUrl] = useState({});
	const [isIndex, setIsIndex] = useState();
	const [isFileChoose, setIsFileChoose] = useState({
		ktp: {},
		nib: {},
		akta: {},
		npwp: {},
		bps: {},
		lainnya: {},
	});
	const [listBank, setListBank] = useState([]);
	const validationNumber = /^\d+$/;
	const isPenciptaOrAhliWaris = [3, 7].includes(getProfile?.role_code);
	// Tooltip NPWP khusus pencipta lagu (role_code 3), bukan ahli waris.
	const isPencipta = getProfile?.role_code === 3;
  

	const handleFileChoose = () => {
		if (getProfile && getProfile?.documents) {
			getProfile.documents.forEach((val) => {
				if (val.document_code === "NIB") {
					setIsFileChoose((prevIsFileChoose) => ({
						...prevIsFileChoose,
						nib: {
							link: val.document_url || null,
							label: val.document_code || "No File Choose",
						},
					}));
				} else if (val.document_code === "Akta Perusahaan") {
					setIsFileChoose((prevIsFileChoose) => ({
						...prevIsFileChoose,
						akta: {
							link: val.document_url || null,
							label: val.document_code || "No File Choose",
						},
					}));
				} else if (val.document_code === "NPWP") {
					setIsFileChoose((prevIsFileChoose) => ({
						...prevIsFileChoose,
						npwp: {
							link: val.document_url || null,
							label: val.document_code || "No File Choose",
						},
					}));
				} else if (val.document_code === "Dokumen Lainnya") {
					setIsFileChoose((prevIsFileChoose) => ({
						...prevIsFileChoose,
						lainnya: {
							link: val.document_url || null,
							label: val.document_code || "No File Choose",
						},
					}));
				} else if (val.document_code === "KTP") {
					setIsFileChoose((prevIsFileChoose) => ({
						...prevIsFileChoose,
						ktp: {
							link: val.document_url || null,
							label: val.document_code || "No File Choose",
						},
					}));
				} else if (val.document_code === "BPS") {
					setIsFileChoose((prevIsFileChoose) => ({
						...prevIsFileChoose,
						bps: {
							link: val.document_url || null,
							label: val.document_code || "No File Choose",
						},
					}));
				}
			});
		}
	};

	const fileInputRef = useRef(null);

	const handleFileChange = (e, index) => {
		const file = e.target.files[0];
		const name = e.target.name;

		if (file) {
			let images = URL.createObjectURL(file);
			let isFilePreview = filePreviewUrl;
			isFilePreview[isIndex] = {
				name: file.name,
				data: images,
			};

			setIsPayload({ ...isPayload, [isIndex]: file });
		}
	};

	const handleButtonClick = (name) => {
		if (fileInputRef.current) {
			fileInputRef.current.click();
			setIsIndex(name);
		}
	};

	const onChange = (e) => {
		const { name, value } = e.target;
		if (
			(name == "account_number" && validationNumber.test(value)) ||
			(name == "account_number" && value == "")
		) {
			setIsForm({ ...isForm, [name]: value });
			setIsPayload({ ...isForm, ...isPayload, [name]: value });
		} else if (name != "account_number") {
			setIsForm({ ...isForm, [name]: value });
			setIsPayload({ ...isForm, ...isPayload, [name]: value });
		}
	};

	useEffect(() => {
		handleFileChoose();
	}, []);

	useEffect(() => {
		API_GET_MAMBOO.dynamic
			.getListBank()
			.then((data) => {
				const isListBank = data.map(({ ur_bank }) => {
					return {
						label: ur_bank,
						value: ur_bank,
					};
				});
				setListBank(isListBank);
			})
			.catch(() => {
				setListBank([]);
			});
	}, []);

	return (
		<>
			<div className="frame-bank-verified">
				<div className="data-bank">
					<div className="text-data-bank">
						{dataBank
							? "Data Bank"
							: isPenciptaOrAhliWaris
								? "Data Bank Songwriter"
								: "Data Bank Publisher"}
					</div>
					<div className="frame-bank">
						<div className="text-nama-bank">*Nama Bank</div>
						{/* <FormInputs
              placeholder="Masukkan nama bank"
              className="frame-wrapper"
              name="bank"
              onChange={onChange}
              value={isForm.bank}
            /> */}
						<FormSelects
							className="frame-wrapper"
							placeholder="Pilih Nama Bank"
							// styles={customStyles}
							options={listBank}
							onChange={(Value) => {
								setIsForm({ ...isForm, bank: Value });
								setIsPayload({ ...isForm, ...isPayload, bank: Value });
							}}
							value={isForm.bank}
						/>
					</div>
					<div className="frame-bank">
						<div className="text-no-rekening">*No Rekening</div>
						<FormInputs
							placeholder="Masukkan no rekening"
							className="frame-wrapper"
							name="account_number"
							onChange={onChange}
							value={isForm.account_number}
						/>
					</div>
					<div className="frame-bank">
						<div className="text-atas-nama">*Atas nama</div>
						<FormInputs
							placeholder="Nama pemilik no rekening"
							className="frame-wrapper"
							name="account_name"
							onChange={onChange}
							value={isForm.account_name}
						/>
					</div>
				</div>
				<div className="upload-dokumen">
					<div className="sub-upload-dokumen">
						<div className="frame-sub-upload">
							<div className="frame-sub-upload-2">
								<div className="text-verifikasi-publisher">
									{uploadDokumen
										? "Upload Dokumen"
										: isPenciptaOrAhliWaris
											? "Verifikasi Songwriter"
											: "Verifikasi Publisher"}
								</div>
								<p className="text-upload-format">
									Upload dengan format : JPEG, PNG, atau PDF
								</p>
							</div>
							<div className="frame-upload-dokumen">
								{addFile ? (
									addFile
								) : (
									<>
										{/* {getProfile && getProfile.documents.length ? 
                  getProfile.documents.map((val, i) => {
                    return (
                      <>
                      <div className="frame-sub-upload-dokumen">
                      <div className="frame-izin-usaha">
                        <div className="frame-sub-izin-usaha">
                          <div className="text-izin-usaha">{val.document_code}</div>
                        </div>
                        <div className="frame-file-izin-usaha">
                          <div className="frame-sub-file-izin-usaha">
                            <div className="text-file" onClick={() => {
                              window.open(filePreviewUrl[i] ? filePreviewUrl[i].data ? filePreviewUrl[i].data : filePreviewUrl[i].document_url : val.document_url)
                            }}>{`File ${ filePreviewUrl[i] ? filePreviewUrl[i].name ? filePreviewUrl[i].name : filePreviewUrl[i].document_code : val.document_code}`}</div>
                          </div>
                          <input
                            type="file"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              handleFileChange(e, i)
                            }}
                            ref={fileInputRef}
                            accept=".jpg,.jpeg,.png,.pdf"
                            name={isIndex >= 0 && getProfile.documents[isIndex].document_code}
                          />
                          <CustomButton
                            label="Upload File"
                            color="primary-btn"
                            className="button-file"
                            ukuran="btn-sm"
                            onClick={() => {
                              handleButtonClick(i)
                            }}
                          />
                        </div>
                      </div>
                    </div>
                      </>
                    )
                  })
                  : 
                  <>
                    <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              <span style={{ color: "red" }}>* </span>NIB
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.nib
                                        ? filePreviewUrl.nib.data
                                        : isFileChoose.nib &&
                                          isFileChoose.nib?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.nib
                                  ? filePreviewUrl.nib.name
                                  : isFileChoose.nib &&
                                    isFileChoose.nib?.label
                                  ? isFileChoose.nib?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="nib"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("nib")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              <span style={{ color: "red" }}>* </span>Akta Perusahaan
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.akta
                                        ? filePreviewUrl.akta.data
                                        : isFileChoose.akta &&
                                          isFileChoose.akta?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.akta
                                  ? filePreviewUrl.akta.name
                                  : isFileChoose.akta &&
                                    isFileChoose.akta?.label
                                  ? isFileChoose.akta?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="akta"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("akta")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              <span style={{ color: "red" }}>* </span>NPWP Perusahaan
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.npwp
                                        ? filePreviewUrl.npwp.data
                                        : isFileChoose.npwp &&
                                          isFileChoose.npwp?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.npwp
                                  ? filePreviewUrl.npwp.name
                                  : isFileChoose.npwp &&
                                    isFileChoose.npwp?.label
                                  ? isFileChoose.npwp?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="npwp"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("npwp")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="frame-sub-upload-dokumen">
                        <div className="frame-izin-usaha">
                          <div className="frame-sub-izin-usaha">
                            <div className="text-izin-usaha">
                              <span style={{ color: "red" }}>* </span>Dokumen Lainnya
                            </div>
                          </div>
                          <div className="frame-file-izin-usaha">
                            <div className="frame-sub-file-izin-usaha">
                              <div
                                className="text-file"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  window.open(
                                    `${
                                      filePreviewUrl && filePreviewUrl?.lainnya
                                        ? filePreviewUrl.lainnya.data
                                        : isFileChoose.lainnya &&
                                          isFileChoose.lainnya?.link
                                    }`
                                  );
                                }}
                              >
                                {filePreviewUrl && filePreviewUrl?.lainnya
                                  ? filePreviewUrl.lainnya.name
                                  : isFileChoose.lainnya &&
                                    isFileChoose.lainnya?.label
                                  ? isFileChoose.lainnya?.label
                                  : "No File Choose"}
                              </div>
                            </div>
                            <input
                              type="file"
                              style={{ display: "none" }}
                              onChange={(e) => {
                                handleFileChange(e);
                              }}
                              ref={fileInputRef}
                              accept=".jpg,.jpeg,.png,.pdf"
                              name="lainnya"
                            />
                            <CustomButton
                              label="Upload File"
                              color="primary-btn"
                              className="button-file"
                              ukuran="btn-sm"
                              onClick={() => handleButtonClick("lainnya")}
                            />
                          </div>
                        </div>
                      </div>
                  </>
                  } */}
										{isPenciptaOrAhliWaris ? (
											<div className="frame-sub-upload-dokumen">
												<div className="frame-izin-usaha">
													<div className="frame-sub-izin-usaha">
														<div className="text-izin-usaha">
															<span style={{ color: "red" }}>* </span>Foto KTP
														</div>
													</div>

													<div className="frame-file-izin-usaha">
														<div className="frame-sub-file-izin-usaha">
															<div
																className="text-file"
																style={{ cursor: "pointer" }}
																onClick={() => {
																	window.open(
																		`${
																			filePreviewUrl && filePreviewUrl?.ktp
																				? filePreviewUrl.ktp.data
																				: isFileChoose?.ktp?.link
																		}`,
																	);
																}}
															>
																{filePreviewUrl && filePreviewUrl?.ktp
																	? filePreviewUrl.ktp.name
																	: isFileChoose?.ktp?.label
																		? isFileChoose.ktp.label
																		: "No File Choose"}
															</div>
														</div>

														<input
															type="file"
															style={{ display: "none" }}
															onChange={(e) => {
																handleFileChange(e);
															}}
															ref={fileInputRef}
															accept=".jpg,.jpeg,.png,.pdf"
															name="ktp"
														/>

														<CustomButton
															label="Upload File"
															color="primary-btn"
															className="button-file"
															ukuran="btn-sm"
															onClick={() => handleButtonClick("ktp")}
														/>
													</div>
												</div>
											</div>
										) : (
											<div className="frame-sub-upload-dokumen">
												<div className="frame-izin-usaha">
													<div className="frame-sub-izin-usaha">
														<div className="text-izin-usaha">
															<span style={{ color: "red" }}>* </span>NIB
														</div>
													</div>
													<div className="frame-file-izin-usaha">
														<div className="frame-sub-file-izin-usaha">
															<div
																className="text-file"
																style={{ cursor: "pointer" }}
																onClick={() => {
																	window.open(
																		`${
																			filePreviewUrl && filePreviewUrl?.nib
																				? filePreviewUrl.nib.data
																				: isFileChoose.nib &&
																					isFileChoose.nib?.link
																		}`,
																	);
																}}
															>
																{filePreviewUrl && filePreviewUrl?.nib
																	? filePreviewUrl.nib.name
																	: isFileChoose.nib && isFileChoose.nib?.label
																		? isFileChoose.nib?.label
																		: "No File Choose"}
															</div>
														</div>
														<input
															type="file"
															style={{ display: "none" }}
															onChange={(e) => {
																handleFileChange(e);
															}}
															ref={fileInputRef}
															accept=".jpg,.jpeg,.png,.pdf"
															name="nib"
														/>
														<CustomButton
															label="Upload File"
															color="primary-btn"
															className="button-file"
															ukuran="btn-sm"
															onClick={() => handleButtonClick("nib")}
														/>
													</div>
												</div>
											</div>
										)}
										{isPenciptaOrAhliWaris ? (
											<div className="frame-sub-upload-dokumen">
												<div className="frame-izin-usaha">
													<div className="frame-sub-izin-usaha">
														<div className="text-izin-usaha">
															<span style={{ color: "red" }}>* </span>Foto NPWP
															{isPencipta && (
																<InfoTooltip
																	id="tooltip-npwp-pencipta"
																	text="Upload Nomor Pokok Wajib Pajak (NPWP) milik Songwriter. Field ini wajib diisi."
																/>
															)}
														</div>
													</div>
													<div className="frame-file-izin-usaha">
														<div className="frame-sub-file-izin-usaha">
															<div
																className="text-file"
																style={{ cursor: "pointer" }}
																onClick={() => {
																	window.open(
																		`${
																			filePreviewUrl && filePreviewUrl?.npwp
																				? filePreviewUrl.npwp.data
																				: isFileChoose.npwp &&
																					isFileChoose.npwp?.link
																		}`,
																	);
																}}
															>
																{filePreviewUrl && filePreviewUrl?.npwp
																	? filePreviewUrl.npwp.name
																	: isFileChoose.npwp &&
																		  isFileChoose.npwp?.label
																		? isFileChoose.npwp?.label
																		: "No File Choose"}
															</div>
														</div>
														<input
															type="file"
															style={{ display: "none" }}
															onChange={(e) => {
																handleFileChange(e);
															}}
															ref={fileInputRef}
															accept=".jpg,.jpeg,.png,.pdf"
															name="npwp"
														/>
														<CustomButton
															label="Upload File"
															color="primary-btn"
															className="button-file"
															ukuran="btn-sm"
															onClick={() => handleButtonClick("npwp")}
															// disabled={isFieldDisabled}
														/>
													</div>
												</div>
											</div>
										) : (
											<div className="frame-sub-upload-dokumen">
												<div className="frame-izin-usaha">
													<div className="frame-sub-izin-usaha">
														<div className="text-izin-usaha">
															<span style={{ color: "red" }}>* </span>Akta
															Perusahaan
														</div>
													</div>
													<div className="frame-file-izin-usaha">
														<div className="frame-sub-file-izin-usaha">
															<div
																className="text-file"
																style={{ cursor: "pointer" }}
																onClick={() => {
																	window.open(
																		`${
																			filePreviewUrl && filePreviewUrl?.akta
																				? filePreviewUrl.akta.data
																				: isFileChoose.akta &&
																					isFileChoose.akta?.link
																		}`,
																	);
																}}
															>
																{filePreviewUrl && filePreviewUrl?.akta
																	? filePreviewUrl.akta.name
																	: isFileChoose.akta &&
																		  isFileChoose.akta?.label
																		? isFileChoose.akta?.label
																		: "No File Choose"}
															</div>
														</div>
														<input
															type="file"
															style={{ display: "none" }}
															onChange={(e) => {
																handleFileChange(e);
															}}
															ref={fileInputRef}
															accept=".jpg,.jpeg,.png,.pdf"
															name="akta"
														/>
														<CustomButton
															label="Upload File"
															color="primary-btn"
															className="button-file"
															ukuran="btn-sm"
															onClick={() => handleButtonClick("akta")}
														/>
													</div>
												</div>
											</div>
										)}
										{isPenciptaOrAhliWaris ? (
											<div className="frame-sub-upload-dokumen">
												<div className="frame-izin-usaha">
													<div className="frame-sub-izin-usaha">
														<div className="text-izin-usaha">Dokumen BPS NPPN</div>
													</div>
													<div className="frame-file-izin-usaha">
														<div className="frame-sub-file-izin-usaha">
															<div
																className="text-file"
																style={{ cursor: "pointer" }}
																onClick={() => {
																	window.open(
																		`${
																			filePreviewUrl && filePreviewUrl?.bps
																				? filePreviewUrl.bps.data
																				: isFileChoose.bps &&
																					isFileChoose.bps?.link
																		}`,
																	);
																}}
															>
																{filePreviewUrl && filePreviewUrl?.bps
																	? filePreviewUrl.bps.name
																	: isFileChoose.bps && isFileChoose.bps?.label
																		? isFileChoose.bps?.label
																		: "No File Choose"}
															</div>
														</div>
														<input
															type="file"
															style={{ display: "none" }}
															onChange={(e) => {
																handleFileChange(e);
															}}
															ref={fileInputRef}
															accept=".jpg,.jpeg,.png,.pdf"
															name="bps"
														/>
														<CustomButton
															label="Upload File"
															color="primary-btn"
															className="button-file"
															ukuran="btn-sm"
															onClick={() => handleButtonClick("bps")}
															// disabled={isFieldDisabled}
														/>
													</div>
												</div>
											</div>
										) : (
											<div className="frame-sub-upload-dokumen">
												<div className="frame-izin-usaha">
													<div className="frame-sub-izin-usaha">
														<div className="text-izin-usaha">
															<span style={{ color: "red" }}>* </span>NPWP
															Perusahaan
														</div>
													</div>
													<div className="frame-file-izin-usaha">
														<div className="frame-sub-file-izin-usaha">
															<div
																className="text-file"
																style={{ cursor: "pointer" }}
																onClick={() => {
																	window.open(
																		`${
																			filePreviewUrl && filePreviewUrl?.npwp
																				? filePreviewUrl.npwp.data
																				: isFileChoose.npwp &&
																					isFileChoose.npwp?.link
																		}`,
																	);
																}}
															>
																{filePreviewUrl && filePreviewUrl?.npwp
																	? filePreviewUrl.npwp.name
																	: isFileChoose.npwp &&
																		  isFileChoose.npwp?.label
																		? isFileChoose.npwp?.label
																		: "No File Choose"}
															</div>
														</div>
														<input
															type="file"
															style={{ display: "none" }}
															onChange={(e) => {
																handleFileChange(e);
															}}
															ref={fileInputRef}
															accept=".jpg,.jpeg,.png,.pdf"
															name="npwp"
														/>
														<CustomButton
															label="Upload File"
															color="primary-btn"
															className="button-file"
															ukuran="btn-sm"
															onClick={() => handleButtonClick("npwp")}
														/>
													</div>
												</div>
											</div>
										)}
										<div className="frame-sub-upload-dokumen">
											<div className="frame-izin-usaha">
												<div className="frame-sub-izin-usaha">
													<div className="text-izin-usaha">
														<span></span>Dokumen
														Lainnya
													</div>
												</div>
												<div className="frame-file-izin-usaha">
													<div className="frame-sub-file-izin-usaha">
														<div
															className="text-file"
															style={{ cursor: "pointer" }}
															onClick={() => {
																window.open(
																	`${
																		filePreviewUrl && filePreviewUrl?.lainnya
																			? filePreviewUrl.lainnya.data
																			: isFileChoose.lainnya &&
																				isFileChoose.lainnya?.link
																	}`,
																);
															}}
														>
															{filePreviewUrl && filePreviewUrl?.lainnya
																? filePreviewUrl.lainnya.name
																: isFileChoose.lainnya &&
																	  isFileChoose.lainnya?.label
																	? isFileChoose.lainnya?.label
																	: "No File Choose"}
														</div>
													</div>
													<input
														type="file"
														style={{ display: "none" }}
														onChange={(e) => {
															handleFileChange(e);
														}}
														ref={fileInputRef}
														accept=".jpg,.jpeg,.png,.pdf"
														name="lainnya"
													/>
													<CustomButton
														label="Upload File"
														color="primary-btn"
														className="button-file"
														ukuran="btn-sm"
														onClick={() => handleButtonClick("lainnya")}
													/>
												</div>
											</div>
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default BankAndVerified;
